import type { DocumentTokenArgs } from "./types";

export const companyDomainPath = (companyDomainId: string) =>
	`/v1/company-domain/${encodeURIComponent(companyDomainId)}`;

export const documentPath = ({
	companyDomainId,
	documentId,
}: DocumentTokenArgs) =>
	`${companyDomainPath(companyDomainId)}/documents/${documentId}`;
